module.exports = function isObject(obj) {
    var type = typeof obj;
    return !!obj && (type === 'function' || type === 'object');
};



// WEBPACK FOOTER //
// ./~/amp-is-object/is-object.js